module.exports = __webpack_public_path__ + "img/image-card-face.05a015ab.png";